import { graphql } from '@teachino/shared-infrastructure';

export const availableCoursesToAddTopicQuery = graphql(`
  query AvailableCoursesToAddTopic($topicId: String!) {
    availableCoursesToAddTopic(topicIdInput: { id: $topicId }) {
      id
      name
      shortName
      backgroundColor
      foregroundColor
    }
  }
`);
